<!-- added by priya 20-02-2026 -->
<div class="info-content"   [ngStyle]="{
    'background-color': statusBgStyle?.bg
}">
    <div class="left-content">
      <wm-common-text
        [data]="{ text: 'Application ' + applicationNumber }"
        class="header"
      ></wm-common-text>
  
      <wm-common-text
        [data]="{
          text: statusLabel + ' on ' + formattedStartedOn + ' by ' + userName
        }"
        class="status-info"
      ></wm-common-text>
    </div>
  
    <div>
      <wm-common-text
        [data]="{ text: statusLabel }"
        class="status"
        [ngStyle]="{
          'background-color': statusStyle?.bg,
          color: statusStyle?.color
        }"
      ></wm-common-text>
    </div>
  </div>